import React from 'react';

import AddModelBooksToPackageButton from '@components/ActivePackages/AddModelBooksToPackageButton';

/** Aggiunge a un package i book della modella contrassegnati come comp card. */
const AddCompCardsButton = ({ modelID, noTooltip }) => (
    <AddModelBooksToPackageButton modelID={modelID} noTooltip={noTooltip} variant="compCards" />
);

export default AddCompCardsButton;
